import { hashCode } from "../../Utils";
import { LayerComponent } from "./LayerComponent";
import { cleanGeoJson } from "../../geo/Geo";
import * as L from "leaflet";

export class GeoJsonComponent extends LayerComponent {
    private _markers?: L.LayerGroup;

    constructor(
        map: L.Map,
        private _markersLayer: L.LayerGroup,
        id: string,
        text: string,
        color: string | undefined,
        weight = 1
    ) {
        super(map, id, "geojson");
        try {
            const geojson = cleanGeoJson(JSON.parse(text));
            const markers = new L.LayerGroup();
            let hasMarkers = false;

            this.layer = L.geoJSON(geojson, {
                style: (feature) => {
                    return { color: color ?? feature?.properties.color, weight };
                },
                pointToLayer: (geojson, latlng) => {
                    if (geojson.properties.name) {
                        let parts = geojson.properties.name.split("-");
                        parts = parts.map((x: string) => x.trim());
                        let name = undefined;
                        if (parts.length === 3) {
                            name = parts[1];
                        }

                        if (name) {
                            new L.Marker(latlng, {
                                icon: new L.DivIcon({
                                    className: "my-div-icon",
                                    html: `<span class="geojson-marker-text">${name}</span>`,
                                }),
                            }).addTo(markers);
                            hasMarkers = true;
                        }
                    }
                    return undefined as unknown as L.Layer;
                },
            });

            if (hasMarkers) {
                this._markers = markers;
            }
        } catch (_ex) {
            // suppress error
            console.log(_ex);
        }
        this.checksum = `${hashCode(text)}`;
    }

    override attachLayer() {
        super.attachLayer();
        if (this._markers) {
            this._markersLayer.addLayer(this._markers);
        }
    }

    override detachLayer() {
        super.detachLayer();
        if (this._markers) {
            this._markersLayer.removeLayer(this._markers);
        }
    }

    override hasChanged(newValue: string): boolean {
        const newHash = `${hashCode(newValue)}`;
        return newHash !== this.checksum;
    }
}
